import searchIndices from "../constants/searchIndices";
export function resolveSearchIndex({
  environment,
  filters,
  sort
}) {
  const sortIndexSuffix = sort ? sort.get('indexSuffix')({
    filters
  }) : undefined;
  return "".concat(searchIndices.getIn([environment, 'indexName'])).concat(sortIndexSuffix ? "_".concat(sortIndexSuffix) : '');
}